import * as React from 'react';

import { Container } from '../../components/Container';
import { SIZE_4, SIZE_16 } from '../../constants/sizes';
import { Text } from '../../components/Text';

import { INewbuilding } from '../../types/newbuilding';

import { UndergroundIcon } from '../UndergroundIcon';
import { Link } from '../../components/Link';
import { NO_BREAK_SPACE } from '../../constants/symbolsUnicode';

export function getMetroInfo(newbuilding: INewbuilding) {
  if (newbuilding.undergroundInfo) {
    const {
      calcTimeWalk,
      calcTimeCar,
      name,
      lineColor,
      fullUrl,
    } = newbuilding.undergroundInfo;
    const regionId = newbuilding.regionId;

    return (
      <Container
        display="inline-flex"
      >
        <Container
          display="inline-flex"
          dataMark="MetroInfo"
        >
          <Link
            url={fullUrl || ''}
            target="blank"
          >
            <Container
              display="inline-flex"
              margin={`0 ${SIZE_4} 0 0`}
            >
              <Container
                display="inline-flex"
                width={SIZE_16}
                margin={`0 ${SIZE_4} 0 0`}
              >
                <span style={{ color: `#${lineColor}`}}>
                  <UndergroundIcon regionId={regionId} />
                </span>
              </Container>
              <Text
                color="black"
                colorHovered="red"
              >
                {name}
              </Text>
            </Container>
          </Link>
        </Container>
        <Text color="gray_4">
          {
            calcTimeWalk && calcTimeWalk <= 20
              ? `${calcTimeWalk}${NO_BREAK_SPACE}мин. пешком`
              : `${calcTimeCar}${NO_BREAK_SPACE}мин.${NO_BREAK_SPACE}на${NO_BREAK_SPACE}транспорте`
          }
        </Text>
      </Container>
    );
  }

  return null;
}
